import { Link } from 'react-router-dom'
import { ChefHat } from 'lucide-react'

export function HeaderBrand() {
  return (
    <Link to="/" className="flex flex-none items-center gap-3">
      <ChefHat className="h-7 w-7 shrink-0 text-orange-500 sm:h-8 sm:w-8" />
      <span className="whitespace-nowrap text-base font-bold text-gray-900 dark:text-slate-50 sm:text-lg lg:text-xl">
        KookInspiratie
      </span>
    </Link>
  )
}
